import React, {Component} from "react";
import PropTypes from "prop-types";
import {Card} from "react-bootstrap";
import AscModal from "../Elements/Modal/Modal";
import {EditCategoryName, EditPromptText} from "../Elements/AscElements/VocCategoryElements";

export default class VocCategoryInsertModal extends Component {
    render() {
        return (
            <AscModal
                state={this.props.state}
                propSetState={this.props.propSetState}
                langText={this.props.langText}
                validationHandle={this.props.validationHandle}
                onClick={this.props.onClick}
            >
                <Card variant="info">
                    <Card.Header>
                        <Card.Title>
                            {this.props.langText.Body.VocCategoryInfo}
                        </Card.Title>
                    </Card.Header>
                    <Card.Body>
                        <EditCategoryName
                            state={this.props.state}
                            langText={this.props.langText}
                            onTextChange_Limit={this.props.onTextChange_Limit}
                            charaLimit={this.props.charaLimit}
                        />
                        <EditPromptText
                            state={this.props.state}
                            langText={this.props.langText}
                            onTextChange_Limit={this.props.onTextChange_Limit}
                            charaLimit={this.props.charaLimit}
                        />
                    </Card.Body>
                </Card>
            </AscModal>
        );
    }
}

VocCategoryInsertModal.propTypes = {
    state: PropTypes.object.isRequired,
    langText: PropTypes.object.isRequired,
    charaLimit: PropTypes.object.isRequired,
    onClick: PropTypes.func.isRequired,
    validationHandle: PropTypes.func.isRequired,
    onTextChange_Limit: PropTypes.func.isRequired,
    propSetState: PropTypes.func,
};
